// the possible values vary depending on whether the user has the ECD role
export enum GapFillabilityEnum {
  NoGap = "---", // probably won't be used in a gap dashboard
  Fillable = "Fillable", // with role
  FillableBySingleProvider = "Fillable By Single Provider", // with or without role
  IncreaseInAccessBySingleProvider = "Increase In Access By Single Provider", // without role
  UnfillableIncreaseInAccess = "Unfillable, Increase in Access", // with role
  UnfillableNoIncreaseInAccess = "Unfillable, No Increase in Access", // with role
}